import { useDispatch, useSelector } from "react-redux";
import { selectCenterBuilding } from "../../../action";
import { capitalize } from "../../../redux/reducers/utils";
import { selectLeanBuilding } from "../../../action/lean_building_pricing/api.actions.getPricingDataForLeanto";

const LTShape = ({ controls, handleStateRendering, handleInfoClick }) => {
	const dispatch = useDispatch();

	const selectedLeanType = useSelector((state) => state.reducer.const_var.selectedLeanType);
	const is_loader = useSelector((state) => state.reducer.const_var.is_loader);
	const isLTBuilding = useSelector((state) => state.reducer.const_var.isLTBuilding);
	const isShowEditConfigurationButton = useSelector((state) => state.reducer.const_var.isShowEditConfigurationButton);
	const isfullviewbuilding = useSelector((state) => state.reducer.isfullviewbuilding);
	const crmSetting = useSelector((state) => state.reducer.const_var.crmSetting);

	const isCBSelected = selectedLeanType === "";

	const params = useSelector((state) => state.reducer.params);

	const toggleCenterLeanto = () => {
		dispatch(selectCenterBuilding());
	};

	const handleLeanBuildingSelection = (leanType) => {
		if (leanType === "") {
			toggleCenterLeanto();
		}
		else {
			dispatch(selectLeanBuilding(leanType, true));
		}
	};

	const buildings = ["", "left", "right", "front", "back"]
		.filter((direction) => {
			if (direction === "") {
				return true;
			} else {
				return !(!params[`add_${direction}_lean`] || params.leanStyle[direction] != "gable");
			}
		})
		.map((direction, index) => {
			return {
				leanType: direction,
				label: window.innerWidth < 992 ? (direction === "" ? "Center" : `${capitalize(direction)}`) + ` (B${index + 1})` : (direction === "" ? "Center" : `${capitalize(direction)}`) + ` (Building ${index + 1})`
			};
		});

	let show = isLTBuilding && !isfullviewbuilding && !isShowEditConfigurationButton && !crmSetting.is_quote_Edit
	return (
		<div className={isLTBuilding ? "lt-building" : "d-none"}>
			<div className={show ? "building-options show-building-opt" : "building-options hide-building-opt"}>
				{buildings.map((building) => {
					const isChecked = selectedLeanType == building.leanType;
					return (
						<h5
							onClick={() => handleLeanBuildingSelection(building.leanType)}
							className={is_loader ? `disabled building ${isChecked ? "building-selected" : ""}` : `building ${isChecked ? "building-selected" : ""}`}
						>
							{building.label}
						</h5>
					);
				})}
			</div>
		</div>
	);
};

export default LTShape;
